"use client";

import React, { createContext, useContext, useState, ReactNode } from "react";

interface TransitionContextType {
    triggerTransition: (href: string) => void;
    isTransitioning: boolean;
    setIsTransitioning: (value: boolean) => void;
    nextRoute: string | null;
    setNextRoute: (value: string | null) => void;
}

const TransitionContext = createContext<TransitionContextType | undefined>(undefined);

export const TransitionProvider = ({ children }: { children: ReactNode }) => {
    const [isTransitioning, setIsTransitioning] = useState(false);
    const [nextRoute, setNextRoute] = useState<string | null>(null);

    const triggerTransition = (href: string) => {
        if (isTransitioning) return;
        setNextRoute(href);
        setIsTransitioning(true);
    };

    return (
        <TransitionContext.Provider
            value={{
                triggerTransition,
                isTransitioning,
                setIsTransitioning,
                nextRoute,
                setNextRoute,
            }}
        >
            {children}
        </TransitionContext.Provider>
    );
};

export const useTransition = () => {
    const context = useContext(TransitionContext);
    if (!context) {
        throw new Error("useTransition must be used within a TransitionProvider");
    }
    return context;
};
